import React from "react";
import { SanityGlobalGoalsResource } from "../../model/dyb";
import TagInfo from "../TagInfo/TagInfo";
import GetText from "../../i18n/GetText";

export const GlobalGoalsResourceTagInfo = ({
  gutterBottom,
  value,
  className
}: {
  gutterBottom?: boolean;
  value: SanityGlobalGoalsResource;
  className?: string;
}) => {
  const { goal } = value;
  const input = !goal
    ? [[]]
    : [
        [
          <span key="goal">
            <GetText id="goal" fallback="Goal" /> {goal.split("-")[1]}
          </span>
        ]
      ];
  return (
    <TagInfo className={className} gutterBottom={gutterBottom} value={input} />
  );
};
